module.exports = __webpack_public_path__ + "img/banner.c7df5aac.png";